import { render, staticRenderFns } from "./ResultGoodsSellersDetail.vue?vue&type=template&id=0194bf24&scoped=true&"
import script from "./ResultGoodsSellersDetail.vue?vue&type=script&lang=js&"
export * from "./ResultGoodsSellersDetail.vue?vue&type=script&lang=js&"
import style0 from "./ResultGoodsSellersDetail.vue?vue&type=style&index=0&id=0194bf24&scoped=true&lang=css&"
import style1 from "./ResultGoodsSellersDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0194bf24",
  null
  
)

export default component.exports